import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PrivacyService } from 'src/app/core/services/privacy/privacy.service';
import { InfoService } from 'src/app/core/services/tables-info/info.service';

@Component({
  selector: 'app-privacy-modal',
  templateUrl: './privacy-modal.component.html',
  styleUrls: ['./privacy-modal.component.scss']
})
export class PrivacyModalComponent implements OnInit {

  disclaimer: string;

  constructor(
    public dialogRef: MatDialogRef<PrivacyModalComponent>,
    private disclaimerService: PrivacyService,) { }

  ngOnInit(): void {
    this.disclaimerService.get()
      .then(() => 
      this.disclaimer = this.disclaimerService.getPrivacyInRegistrationDisclaimer().description,
      err => console.error(err));
    
  }

  closeModal() {
    this.dialogRef.close(true);
  }

}
